
// NATIVE 


// INSTALLED 


// CUSTOM 
import dayjs from 'dayjs';
import { setCargosRedux } from '../cargos';
import { calcularDiferenciaHoras } from '../../commons/utils';
import { checkingPreload, unCheckingPreload } from '../loading';
import { hideIconRequestErrors, showIconRequestErrors } from '../errors';
import { hideDaysErrorRedux, setTurnosRedux, showDaysErrorRedux, storeTurnoRedux } from './shiftsSlice';
import { activeTurnoService, createShiftService, desactiveTurnoService, getAllShiftsByPaginateService, 
         getShiftsAllService, getTurnoDetailService } from '../../services/shifts.service';






export const getShiftsStore = (): any => {

    return async( dispatch: any ) => {


      await dispatch( checkingPreload() );



      const result = await  getShiftsAllService();
    
     
      dispatch( unCheckingPreload() );

      if ( result.ok ) {

        
          // TURNOS 
          // await AsyncStorage.setItem(types.storage.turnosStorage, JSON.stringify(result.data));
          await dispatch( setTurnosRedux(result.data) );

          // positionS 
          // await AsyncStorage.setItem(types.storage.positionsStorage, JSON.stringify(result.data.positions));
          await dispatch( setCargosRedux(result.data.positions) );

      }
      
      return result;
        
    }
}




export const getTurnosByPagination = (page:number): any => {

    return async( dispatch: any ) => {


      await dispatch( checkingPreload() );
      await dispatch( hideIconRequestErrors() );


      const result = await  getAllShiftsByPaginateService(page);


      if ( result.ok ) {
           await dispatch( setTurnosRedux(result.data) );
      }
    
      dispatch( unCheckingPreload() );
      
      return result;
        
    }

}




export const storeCreateTurno = (position: any, percentage:any): any => {


    return async( dispatch: any ) => { 


      // await dispatch( checkingPreload() );



      const start_minute = dayjs( position.start_hour).minute().toString();
      const end_minute = dayjs( position.start_hour).minute().toString(); 


      const startMinuteFormated = ( start_minute.length > 1 ) ? dayjs( position.start_hour).minute() : '0'+dayjs( position.start_hour).minute();
      const endMinuteFormated = ( end_minute.length > 1 ) ? dayjs( position.end_hour).minute() : '0'+dayjs( position.end_hour).minute();

      const typeShift =  (( position.festivo ) ? 'F' : '') + (( position.domingo ) ? 'D' : '') + (( position.sabado ) ? 'S' : '');


      const diferenciaManual = calcularDiferenciaHoras( dayjs( position.start_hour).hour() +':'+startMinuteFormated.toString(), dayjs( position.end_hour).hour() +':'+endMinuteFormated.toString() );
      //  console.log(`Diferencia: ${diferenciaManual.horas} horas y ${diferenciaManual.minutos} minutos`);
      // console.log(position)
      // console.log('typeShift ',typeShift)
      // console.log(position.cargo.label+' '+diferenciaManual.horas+'h '+position.tipoTurno+' '+typeShift)
      const nameShift = position.cargo.label+' '+diferenciaManual.horas+'h '+position.tipoTurno+' '+typeShift;
      

      // console.log('kenepappappa')
     
      const turno = {

            
            name:  nameShift.trim(),
            position: position.cargo.value,
            hora_entrada:  dayjs( position.start_hour).hour() +':'+startMinuteFormated,
            hora_salida: dayjs( position.end_hour).hour() +':'+endMinuteFormated,
            tarifa: position.tarifa,
            lunes:  Number(position.lunes),
            martes: Number(position.martes),
            miercoles: Number(position.miercoles),
            jueves: Number(position.jueves),
            viernes: Number(position.viernes),
            sabado: Number(position.sabado),
            domingo: Number(position.domingo),
            festivo: Number(position.festivo),
            year: position.anio
        
      };

      


      const result = await  createShiftService(turno, percentage);

   
      if (result.ok) {
          await dispatch( setTurnosRedux(result.data) );
      }

      
      // dispatch( unCheckingPreload() );

      return result;



    }



}




export const storeDesactiveTurno = (turnoId: string): any => {
    

  return async( dispatch: any ) => { 

      await dispatch( checkingPreload() );

      const result = await  desactiveTurnoService(turnoId);

      if ( result.ok ) {
        await dispatch( setTurnosRedux(result.data) );
      }


      dispatch( unCheckingPreload() );


      return result;

  }

    
}




export const storeActiveTurno = (turnoId: string): any => {
  

  return async( dispatch: any ) => { 

      await dispatch( checkingPreload() );

      const result = await  activeTurnoService(turnoId);

      
      dispatch( unCheckingPreload() );

      if ( result.ok ) {
           await dispatch( setTurnosRedux(result.data) );
      }

      return result;

  }

    
}




export const storeDetailTurno = (turnoId: string): any => {
    

  return async( dispatch: any ) => { 


      await dispatch( checkingPreload() );
      await dispatch( hideIconRequestErrors() );
      

      const result = await  getTurnoDetailService(turnoId);
    
      

      ( result.ok ) ? dispatch( hideIconRequestErrors() )  : dispatch( showIconRequestErrors() );
      
      dispatch( unCheckingPreload() );

      if ( result.ok ) {           

        const dataTurno = {
            id: result.data.shift.id,
            name: result.data.shift.name,
            hora_entrada: result.data.shift.hora_entrada,
            hora_salida: result.data.shift.hora_salida,
            tarifa: result.data.shift.tarifa.toString(),
            lunes: (result.data.shift.lunes) ? true : false,
            martes: (result.data.shift.martes) ? true : false,
            miercoles: (result.data.shift.miercoles) ? true : false,
            jueves: (result.data.shift.jueves) ? true : false,
            viernes: (result.data.shift.viernes) ? true : false,
            sabado: (result.data.shift.sabado) ? true : false,
            domingo: (result.data.shift.domingo) ? true : false,
            festivo: (result.data.shift.festivo) ? true : false,
            year: result.data.shift.year.toString(),
            position: {
                id: ( result.data.shift.position.id ) ? result.data.shift.position.id : "aa",
                name: ( result.data.shift.position.name ) ? result.data.shift.position.name : "bb",
                description: ( result.data.shift.position ) ? result.data.shift.position.description: "",
                visita_domiciliaria: ( result.data.shift.position ) ? result.data.shift.position.visita_domiciliaria : 0,
                prueba_psicotecnica: ( result.data.shift.position ) ? result.data.shift.position.prueba_psicotecnica : 0,
                examen_alimentos: ( result.data.shift.position ) ? result.data.shift.position.examen_alimentos : 0,
                examen_alturas: ( result.data.shift.position ) ? result.data.shift.position.examen_alturas : 0,
                certificado_laboral: ( result.data.shift.position ) ? result.data.shift.position.certificado_laboral : 0,
                certificado_estudios: ( result.data.shift.position ) ? result.data.shift.position.certificado_estudios : 0,
                adres: ( result.data.shift.position ) ? result.data.shift.position.adres : 0,
                antecedentes_judicial: ( result.data.shift.position ) ? result.data.shift.position.antecedentes_judicial : 0,
                entrevista: ( result.data.shift.position ) ? result.data.shift.position.entrevista : 0,
                sociodemografica: ( result.data.shift.position ) ? result.data.shift.position.sociodemografica : 0,
                dme: ( result.data.shift.position ) ? result.data.shift.position.dme : 0,
                sst: ( result.data.shift.position ) ? result.data.shift.position.sst : 0
            }
        }
           await dispatch( storeTurnoRedux(dataTurno) );
      }

      return result;

  }

    
}





export const showDaysWeekCreateShiftError = (): any => {


  return async( dispatch: any ) => {

      await dispatch( showDaysErrorRedux() );
  
  }


}


export const hideNotDaysWeekCreateShiftError = (): any => {


  return async( dispatch: any ) => {

      await dispatch( hideDaysErrorRedux() );
  
  }


}








